import { ReactNode } from 'react';
import { RowData } from '@tanstack/react-table';
import { UserProcResponse } from '@/shared/api';

// TanStack doesn't have specific property to set align, put it
// inside "meta" field to provide access to it from table object
declare module '@tanstack/react-table' {
  interface ColumnMeta<TData extends RowData, TValue> {
    align?: 'left' | 'center' | 'right';
  }
}

export enum ComponentType {
  Text = 'text',
  Input = 'input',
  TextArea = 'textArea',
  Image = 'image',
  Video = 'video',
  Checkbox = 'checkbox',
  Select = 'select',
  Embedding = 'embedding',
}

export type ComponentItemType = {
  id: Uncapitalize<ComponentType>;
  icon?: ReactNode;
  title?: string;
};

export enum ComponentMode {
  Preview = 'preview',
  Edit = 'edit',
  Input = 'input',
  Disabled = 'disabled',
}

export enum DndItemType {
  StepItem = 'stepItem',
  ComponentItem = 'componentItem',
  CanvasComponentItem = 'canvasComponentItem',
}

export type ProgressStatus = 'normal' | 'exception' | 'active' | 'success';

export enum NotificationType {
  UserAddedComment = 'userAddedComment',
  WorkspaceMemberAddedComment = 'workspaceMemberAddedComment',
  UserCompletedProc = 'userCompletedProc',
  Subscriptions = 'subscriptions',
}

export type UserInstanceParams = {
  procId?: string;
  code?: string;
};

export type ProcState = UserProcResponse['state'];

export enum DashboardSidebarRightTabsType {
  Components = 'components',
  Logic = 'logic',
}

export enum ConditionComponentsType {
  Checkbox = 'checkbox',
  Select = 'select',
}

export type LogicComponentOperator = 'is' | 'is not';

export type LogicRule = {
  id: string;
  // operator: LogicConditionOperator;
  component?: {
    id: string;
    type: ComponentType;
  };
  value?: string | boolean;
  operator?: LogicComponentOperator;
  goToStep?: string; // stepId
};

export enum EventTypes {
  STEP_ADDED = 'STEP_ADDED',
  COMPONENT_ADDED_TO_CANVAS = 'COMPONENT_ADDED_TO_CANVAS',
  NOTIFICATIONS_SIDEBAR_ITEM_CLICKED = 'NOTIFICATIONS_SIDEBAR_ITEM_CLICKED',
}

export enum ChatMode {
  Author = 'author',
  User = 'user',
  Preview = 'preview',
}

// Workspace role types matching the server-side enum
export enum WorkspaceRoleType {
  ADMIN = 'admin',
  READER = 'reader',
}
